import EtherscanStyleTxDetails from '../components/transaction/EtherscanStyleTxDetails';
import { useEvmTransaction } from '../hooks/useEvmTransaction';

function EvmTransactionDetailsView({ hash }) {
  const { display, loading, error } = useEvmTransaction(hash);

  return (
    <EtherscanStyleTxDetails
      display={display}
      loading={loading}
      error={error}
      title="Transaction Details"
    />
  );
}

export default EvmTransactionDetailsView;
